<div class="thc-cbd-group-block {{partnerName}}">
    <ng-container *ngFor="let group of dataList">
        <div class="thc-cbd-group-item" [class.thc-item]="getTHCCBDItem(group, 'THC')" [class.cbd-item]="getTHCCBDItem(group, 'CBD')" [class.active]="group.No===selectedGroup.No" [class.recommended]="checkRecommended(group)" (click)="selectGroup(group)">
            <div class="thc-cbd-group-title">{{group.Title}}</div>
            <!--<div class="thc-cbd-group-value">
                <div class="item-value">
                    <div class="text">THC</div>
                    <div class="value">{{group.THC.Value}}{{group.THC.Equality || ""}}</div>
                </div>
                <div class="item-value">
                    <div class="text">CBD</div>
                    <div class="value">{{group.CBD.Value}}{{group.CBD.Equality || ""}}</div>
                </div>
            </div>-->
        </div>
    </ng-container>
</div>
